module.exports = __webpack_public_path__ + "media/src/components/PersonalAccidentInsurancePage/WhyNeedSection/2-07d2b75b97f28efeca47c447e2cf8df6.png";